import React from "react";
import {
  Table,
  Segment,
  Button,
  Header,
  Message,
  Grid,
  Icon,
} from "semantic-ui-react";
import { normalizeId } from "../../../../../formatting/inventoryIds";

const CompletedStep = ({ supplyUnits, mergedInventory, onFinish }) => {
  // Get the total count of all supply units
  const totalSupplyUnits = supplyUnits.length;

  // Calculate total inventory value
  const totalInventoryValue = supplyUnits.reduce(
    (sum, unit) => sum + (unit.inv || 0),
    0
  );

  // Get unique original inventory IDs (before merge)
  const originalInventoryIds = [
    ...new Set(
      supplyUnits
        .map((unit) => unit.originalInventoryId || unit.inventory_id)
        .filter((id) => id !== mergedInventory.inventory_id)
    ),
  ];

  return (
    <Segment>
      {/* Success message */}
      <Message positive icon>
        <Icon name="check circle" />
        <Message.Content>
          <Message.Header>Inventory Merge Completed</Message.Header>
          <p>The inventory merge has been successfully processed.</p>
        </Message.Content>
      </Message>

      {/* Summary header */}
      <Header as="h3">Merge Summary</Header>
      <p>Here's a summary of your inventory merge:</p>

      {/* Display the count of merged inventory records */}
      <Message info>
        <p>
          Successfully merged <strong>{originalInventoryIds.length + 1}</strong>{" "}
          inventory
          {originalInventoryIds.length > 0 ? " records" : " record"} into a
          single inventory with <strong>{totalSupplyUnits}</strong> total supply
          units.
        </p>
      </Message>

      {/* Merged Inventory Section */}
      <Header as="h4">Merged Inventory Details</Header>
      <Segment secondary style={{ marginBottom: "20px", marginTop: "20px" }}>
        <Grid>
          <Grid.Row>
            <Grid.Column width={8}>
              <Header as="h4">Inventory Title</Header>
              <p>{mergedInventory.inventory_title}</p>

              <Header as="h4">Shelf</Header>
              <p>{mergedInventory.shelf}</p>

              <Header as="h4">Inventory Value</Header>
              <p>{mergedInventory.inv}</p>
            </Grid.Column>
            <Grid.Column width={8}>
              <Header as="h3">
                Inventory ID: {normalizeId(mergedInventory.inventory_id)}
              </Header>
              <p>Component #: {mergedInventory.part_number}</p>
              <p>{totalSupplyUnits} total supply units</p>
            </Grid.Column>
          </Grid.Row>
        </Grid>
      </Segment>

      {/* Supply Units Table */}
      <Header as="h4">Merged Supply Units</Header>
      <Table celled>
        <Table.Header>
          <Table.Row>
            <Table.HeaderCell>UPC</Table.HeaderCell>
            <Table.HeaderCell>Title</Table.HeaderCell>
            <Table.HeaderCell>Inventory</Table.HeaderCell>
          </Table.Row>
        </Table.Header>
        <Table.Body>
          {supplyUnits.map((unit, index) => (
            <Table.Row key={`${unit.upc}-${index}`}>
              <Table.Cell>{unit.upc}</Table.Cell>
              <Table.Cell>{unit.title}</Table.Cell>
              <Table.Cell>{unit.inv || 0}</Table.Cell>
            </Table.Row>
          ))}
        </Table.Body>
        <Table.Footer>
          <Table.Row>
            <Table.HeaderCell colSpan="2">
              <strong>Total</strong>
            </Table.HeaderCell>
            <Table.HeaderCell>
              <strong>{totalInventoryValue}</strong>
            </Table.HeaderCell>
          </Table.Row>
        </Table.Footer>
      </Table>

      {/* Action buttons */}
      <div
        style={{
          marginTop: "20px",
          display: "flex",
          justifyContent: "center",
        }}
      >
        <Button primary onClick={onFinish}>
          Finish
        </Button>
      </div>
    </Segment>
  );
};

export default CompletedStep;
